import { Button, ListItemText, makeStyles, Menu, MenuItem } from '@material-ui/core';
import React, { MouseEvent, useCallback, useContext, useEffect, useState } from 'react';
import { MdHelpOutline } from 'react-icons/md';
import LocalizationContext from '../../contexts/LocalizationContext';
import { AccountContext } from '../apps/account/context/AccountProvider';
import { HelperlinkData } from '../apps/account/interfaces/IAppLayouts';

interface HelperMenuProps {
    appName?: string;
    isManager?: boolean;
    subAppName?: string;
    appId?: number;
    subAppId?: number | null;
}

const useStyles = makeStyles({
    help: {
        width: '45px',
        height: '100%',
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
        outline: 0,
        cursor: 'pointer',
        '&:hover, &:focus, &:active, &:visited': {
            textDecoration: 'none',
            color: 'inherit',
            outline: 0,
            cursor: 'pointer',
        },
    },
});

const HelperMenu = ({ appName, subAppName, isManager, appId, subAppId }: HelperMenuProps) => {
    const localization = useContext(LocalizationContext);
    const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
    const [links, setlinks] = useState<HelperlinkData[]>([]);
    const classes = useStyles();
    const account = useContext(AccountContext);

    const handleClick = useCallback(
        (e: MouseEvent<HTMLElement>) => {
            if (links.length > 1) {
                setMenuAnchor(e.currentTarget);
                return;
            }
        },
        [links]
    );

    useEffect(() => {
        if (appName) {
            let listOfLinks: HelperlinkData[] =
                account.links.filter((link: HelperlinkData) => link.appId === appId && link.subAppId === subAppId) ?? [];
            setlinks(listOfLinks);
        }
    }, [appName, account.links, appId, subAppId]);

    return (
        <>
            {links.length > 1 ? (
                <Button
                    title={localization.strings.openHelpLinks}
                    onClick={(e: MouseEvent<HTMLElement>) => handleClick(e)}
                    className={classes.help}>
                    <MdHelpOutline size={'1.5em'} />
                </Button>
            ) : (
                links.length === 1 && (
                    <a href={links[0].link[localization.lang]} target='_blank' rel='noreferrer' className={classes.link}>
                        <Button onClick={() => {}} className={classes.help}>
                            <MdHelpOutline title={links[0].text[localization.lang]} size={'1.5em'} />
                        </Button>
                    </a>
                )
            )}
            <Menu open={!!menuAnchor} anchorEl={menuAnchor} keepMounted onClose={() => setMenuAnchor(null)}>
                {links &&
                    links.map((l: HelperlinkData, i: number) => (
                        <a href={l.link[localization.lang]} target='_blank' rel='noreferrer' className={classes.link} key={i}>
                            <MenuItem key={l.id} style={{ minWidth: '200px' }} onClick={() => {}}>
                                <ListItemText primary={l.text[localization.lang]} />
                            </MenuItem>
                        </a>
                    ))}
            </Menu>
        </>
    );
};

export default HelperMenu;
